import React from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon, StarIcon, TrophyIcon, XIcon } from 'lucide-react';
import { useSession } from '../contexts/SessionContext';
import { CHAMPION_SHIRT_PATH, bannerConfetti } from '../data/site';
type ChampionBannerProps = {
  layout: 'contained' | 'fullBleed';
  visible: boolean;
};
export function ChampionBanner({
  layout,
  visible
}: ChampionBannerProps) {
  const {
    championPlayerName,
    dismissChampionBanner
  } = useSession();
  const reduceMotion = useReducedMotion();
  return <AnimatePresence initial={false} data-id="element-17" data-mp="gvusddgnkm2q">
      {visible && <motion.section aria-label="League Champion shirt offer" className="relative overflow-hidden bg-[#1F3BB3] text-white" exit={reduceMotion ? {
      opacity: 0
    } : {
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-18" data-mp="kxpv8me8f7im">
          <div className="pointer-events-none absolute inset-0" aria-hidden data-id="element-19" data-mp="1zo8b4dnohtkv">
            {bannerConfetti.map((c, i) => <span key={i} className="absolute rounded-[1px] opacity-70" style={{
          left: c.left,
          top: c.top,
          width: c.size,
          height: c.size,
          backgroundColor: c.color,
          transform: `rotate(${c.rotate}deg)`
        }} data-id="element-20" data-mp="1uonfac3t21cd" data-mpi={i} />)}
          </div>
          <div className={`relative ${layout === 'fullBleed' ? 'mx-auto w-full max-w-[1600px]' : ''}`} data-id="element-21" data-mp="1gpw3wxgbutrx">
            <div className="flex min-h-[80px] flex-wrap items-center gap-x-4 gap-y-3 px-6 py-4" data-id="element-22" data-mp="1bydzfzf3ib27">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-gold/70 bg-[#3B2A0A] text-gold shadow-[inset_0_1px_0_rgba(255,255,255,0.15)]" aria-hidden data-id="element-23" data-mp="16yt19r7r26qj">
                <TrophyIcon className="h-6 w-6" strokeWidth={2} data-id="element-24" data-mp="xz5x4xnmymts" />
              </span>
              <div className="min-w-0 flex-1" data-id="element-25" data-mp="t01me2l2ch1c">
                <span className="inline-flex items-center gap-1 rounded-sm bg-gold px-1.5 py-0.5 text-[11px] font-bold uppercase tracking-wide text-navy" data-id="element-26" data-mp="t0bebvpo4y9o">
                  <StarIcon className="h-3 w-3 fill-navy" aria-hidden data-id="element-27" data-mp="neane921jt8s" />
                  Championship Winner Exclusive
                </span>
                <p className="mt-1 text-lg leading-snug md:text-xl" data-id="element-28" data-mp="9fks8yys83n2">
                  <span className="font-condensed text-2xl font-bold uppercase tracking-tight md:text-[26px]" data-id="element-29" data-mp="ecb7jk2riv7f">
                    {championPlayerName} is a League Champion!
                  </span>{' '}
                  <span className="text-white/85" data-id="element-30" data-mp="170qinvirwtdh">Celebrate with the official Champion shirt — available for a limited time.</span>
                </p>
              </div>
              <div className="flex items-center gap-2" data-id="element-31" data-mp="xbp489rvmk1m">
                <Link to={CHAMPION_SHIRT_PATH} className="group flex items-center gap-2 whitespace-nowrap rounded bg-gold px-5 py-2.5 font-bold uppercase tracking-wide text-navy shadow-[0_2px_0_#B9830F] transition-colors duration-150 hover:bg-gold-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-32" data-mp="xa48igttsv26">
                  Shop Champion Shirt
                  <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden data-id="element-33" data-mp="35hhgc18dhe7v" />
                </Link>
                <button onClick={dismissChampionBanner} aria-label="Dismiss champion banner" className="flex h-10 w-10 items-center justify-center rounded text-white/70 transition-colors duration-150 hover:bg-white/10 hover:text-white" data-id="element-34" data-mp="3f955twldcl6p">
                  <XIcon className="h-5 w-5" data-id="element-35" data-mp="30lk3w608cs0d" />
                </button>
              </div>
            </div>
          </div>
        </motion.section>}
    </AnimatePresence>;
}